var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"leasing-comparator__error error"},[_c(_setup.VueFeedback,{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v("Hoppá!")]),_c('template',{slot:"feedback-content"},[_c('p',[_vm._v("Hiba történt")])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }